import { jsxs as c, jsx as a } from "@emotion/react/jsx-runtime";
import { useId as y } from "react";
import { RadioContainer as k, RadioInput as g, StyledIcon as j, InnerCircleRing as v, RadioMark as C } from "./Radio.styled.js";
const M = () => /* @__PURE__ */ c("g", { children: [
  /* @__PURE__ */ a("circle", { cx: "12", cy: "12", r: "8", strokeWidth: "1" }),
  /* @__PURE__ */ a(v, { cx: "12", cy: "12", r: "6" }),
  /* @__PURE__ */ a(C, { cx: "12", cy: "12", r: "4" })
] }), F = ({
  dataTrackId: n,
  checked: o = !1,
  onChange: l,
  onFocus: m,
  onBlur: s,
  disabled: r = !1,
  error: e,
  name: p,
  value: x,
  size: i = 24,
  children: I,
  className: R,
  autoFocus: f,
  onKeyDown: h,
  ref: u
}) => {
  const d = y(), t = `radio-${d}`;
  return /* @__PURE__ */ c(k, { "data-track": n, as: "label", "aria-disabled": r, htmlFor: t, className: R, "data-checked": o, "data-error": !!e, children: [
    /* @__PURE__ */ a(g, { type: "radio", "aria-invalid": !!e, "aria-disabled": r, checked: o, id: t, onChange: l, onFocus: m, onKeyDown: h, onBlur: s, value: x, disabled: r, name: p ?? d, autoFocus: f, ref: u, size: i }),
    /* @__PURE__ */ a(j, { size: i, viewBox: "0 0 24 24", children: /* @__PURE__ */ a(M, {}) }),
    I
  ] });
};
export {
  F as Radio
};
